import React from 'react';
import {SelectInput} from '~/components/Controls/Select';
import {useAbility} from '~/lib/ability';
import {useResource} from '~/lib/loader';
import {fetchAgencies} from '~/modules/Clients/api';
import {useSession} from '~/modules/Profile/session';
import {RootAbility} from '~/root_ability';
import style from './index.module.scss';

export const AgencySwitcher = () => {
    const ability = useAbility(RootAbility);
    const {session, setSelectedAgency} = useSession();
    const {resource: agencies, isPending} = useResource(() => fetchAgencies(), []);

    if (!ability.isBuyer()) return null;

    const items = agencies.map(a => ({label: a.title, value: a.id}));
    if (!isPending && items.length <= 1) return null;

    return (
        <SelectInput
            value={session.selectedAgencyId}
            items={items}
            disabled={isPending}
            onChange={(id) => setSelectedAgency?.(id)}
            className={style.agencySwitcher}
            searchable
        />
    );
};
